import React, { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
// eslint-disable-next-line
// @ts-ignore
import { i18n as _i18n } from 'i18next';

import i18nextFallbackInstance from 'src/config/i18n';

export interface TranslationsProviderProps {
  // eslint-disable-next-line
  i18n?: any;
  children?: ReactNode | React.ReactElement[];
}

const I18NProvider: React.FC<TranslationsProviderProps> = (props) => {
  const { i18n, children } = props;

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <I18nextProvider i18n={(i18n as typeof _i18n) ?? i18nextFallbackInstance}>
      {children}
    </I18nextProvider>
  );
};

export default I18NProvider;
